enum TrackerActionEnum {
  None = 'none',
  AddGroup = 'add-group',
  ModifyGroup = 'modify-group',
  DeleteGroup = 'delete-group',
  AddActivity = 'add-activity',
  ModifyActivity = 'modify-activity',
  DeleteActivity = 'delete-activity',
}

enum ActionEnum {
  Add = 'add',
  Modify = 'modify',
  Delete = 'delete',
}

export { ActionEnum, TrackerActionEnum };
